export const SITE_URL = "https://www.guesthousebamboubeach.com";

const PAGES = {
  home: {
    canonicalPath: "/",
    fr: {
      title: "Guesthouse Bambou Beach — Maison d'hôtes en bord de mer à Grand-Popo, Bénin",
      description:
        "Maison d'hôtes les pieds dans le sable à Grand-Popo, Bénin. 4 chambres, petit-déjeuner inclus, Wi-Fi gratuit. Réservez en direct et économisez 15%.",
    },
    en: {
      title: "Guesthouse Bambou Beach — Beachfront Guesthouse in Grand-Popo, Benin",
      description:
        "Beachfront guesthouse in Grand-Popo, Benin. 4 rooms, breakfast included, free Wi-Fi. Book direct and save 15%.",
    },
  },
  rooms: {
    canonicalPath: "/chambres",
    fr: {
      title: "Nos 4 chambres — Guesthouse Bambou Beach, Grand-Popo",
      description:
        "Chambres Patio, Ocean, Tintin et Sosso : dès 50€/nuit, vue mer, climatisation, salle de bain privée. Petit-déjeuner et Wi-Fi inclus.",
    },
    en: {
      title: "Our 4 Rooms — Guesthouse Bambou Beach, Grand-Popo",
      description:
        "Patio, Ocean, Tintin and Sosso rooms: from €50/night, sea view, air conditioning, private bathroom. Breakfast and Wi-Fi included.",
    },
  },
  gallery: {
    canonicalPath: "/galerie",
    fr: {
      title: "Galerie photos — Guesthouse Bambou Beach, Grand-Popo",
      description:
        "Découvrez en images la plage de Grand-Popo, les terrasses ombragées et les chambres de la Guesthouse Bambou Beach au Bénin.",
    },
    en: {
      title: "Photo Gallery — Guesthouse Bambou Beach, Grand-Popo",
      description:
        "Discover Grand-Popo beach, shaded terraces and the rooms of Guesthouse Bambou Beach in Benin, in pictures.",
    },
  },
  location: {
    canonicalPath: "/grand-popo",
    fr: {
      title: "Grand-Popo, Bénin — Comment venir à la Guesthouse Bambou Beach",
      description:
        "Située au quartier Ayi-Guinnou à Grand-Popo, sur la côte atlantique du Bénin. À 1h30 de l'aéroport de Cotonou, navette sur demande.",
    },
    en: {
      title: "Grand-Popo, Benin — Getting to Guesthouse Bambou Beach",
      description:
        "Located in the Ayi-Guinnou quarter of Grand-Popo, on Benin's Atlantic coast. 1h30 from Cotonou airport, shuttle on request.",
    },
  },
  activities: {
    canonicalPath: "/activites",
    fr: {
      title: "Activités & circuits à Grand-Popo — Guesthouse Bambou Beach",
      description:
        "Mangrove, Bouche du Roy, villages Vodoun, campements peulhs : 4 circuits organisés avec les guides locaux de Grand-Popo, Bénin.",
    },
    en: {
      title: "Activities & Tours in Grand-Popo — Guesthouse Bambou Beach",
      description:
        "Mangrove, King's Mouth, Vodoun villages, Fulani camps: 4 tours organized with local guides in Grand-Popo, Benin.",
    },
  },
  booking: {
    canonicalPath: "/reserver",
    fr: {
      title: "Réserver en direct — Guesthouse Bambou Beach, Grand-Popo",
      description:
        "Réservez votre chambre en direct à la Guesthouse Bambou Beach et économisez 15%. Réponse sous 24h par email ou WhatsApp.",
    },
    en: {
      title: "Book Direct — Guesthouse Bambou Beach, Grand-Popo",
      description:
        "Book your room directly at Guesthouse Bambou Beach and save 15%. Reply within 24h by email or WhatsApp.",
    },
  },
  contact: {
    canonicalPath: "/contact",
    fr: {
      title: "Contact — Guesthouse Bambou Beach, Grand-Popo, Bénin",
      description:
        "Contactez la Guesthouse Bambou Beach par WhatsApp, email ou formulaire. Votre hôte Jacky vous répond personnellement.",
    },
    en: {
      title: "Contact — Guesthouse Bambou Beach, Grand-Popo, Benin",
      description:
        "Reach Guesthouse Bambou Beach by WhatsApp, email or contact form. Your host Jacky answers personally.",
    },
  },
};

const ROUTE_TO_PAGE = {
  "/": "home",
  "/chambres": "rooms",
  "/rooms": "rooms",
  "/galerie": "gallery",
  "/gallery": "gallery",
  "/grand-popo": "location",
  "/location": "location",
  "/activites": "activities",
  "/activities": "activities",
  "/reserver": "booking",
  "/book": "booking",
  "/contact": "contact",
};

export function getPageSeo(pathname, lang) {
  const page = PAGES[ROUTE_TO_PAGE[pathname] || "home"];
  return { canonicalPath: page.canonicalPath, ...page[lang] };
}
